import { memo, useMemo } from "react";

import EvalTableShimmer from "./EvalTableShimmer";
import FormattedTable from "./FormattedTable";

import { ReportColumn } from "@/types/evaluate";
import { useReportContext } from "@/components/Evaluate/report-context";

const Body = () => {
  const reportContext = useReportContext();
  const columns: ReportColumn[] = reportContext.sortedColumns;
  const { visibleRows } = reportContext;
  const { sortedRowIds } = reportContext;
  const { currentPage } = reportContext;
  const { pageSize } = reportContext;
  const { filters } = reportContext;

  // Show shimmer when data is loading
  // Check multiple conditions to avoid empty state
  const isLoading =
    visibleRows === null ||
    reportContext.reportCells === null ||
    columns.length === 0 ||
    (reportContext.reportCells?.length && reportContext.reportCells?.every(cell => !cell));

  const emptyMessage = useMemo(() => {
    if (!visibleRows || visibleRows.length === 0) {
      return filters && Object.keys(filters).length > 0
        ? "No rows found matching the current filters."
        : "No rows found.";
    }
  }, [visibleRows, filters]);

  if (isLoading) {
    return (
      <EvalTableShimmer
        columnCount={columns.length || 5}
        rowCount={pageSize}
        showPagination
        hasHiddenColumns={false}
      />
    );
  }

  return (
    <FormattedTable
      data={sortedRowIds || []}
      emptyMessage={emptyMessage}
      currentPage={currentPage}
      pageSize={pageSize}
    />
  );
};

const EvalTableSection = ({ searchable }: { searchable?: boolean }) => {
  if (!searchable) {
    return <Body />;
  }

  return (
    <div className="flex min-h-0 w-full flex-1 flex-col">
      <Body />
    </div>
  );
};

export default memo(EvalTableSection);
